import { Injectable } from '@angular/core';
import { createEffect } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/nx';
import { map } from 'rxjs/operators';

import { DiagnosisPartialState, DiagnosisActions } from './diagnosis.state';
import { DiagnosisService } from '../data-access.service';

@Injectable()
export class  DiagnosisEffects {

  loadAllEntities$ = createEffect(() => this.dataPersistence.fetch(DiagnosisActions.LoadAll.type, {
    run: (action: any, state) => this.apiService.getAll(action.payload)
                                      .pipe(map(response => DiagnosisActions.LoadedAll({ payload: response }))),
    onError: (action: any, error) => DiagnosisActions.ActionError(action + error)
  }));

  createEntity$ = createEffect(() => this.dataPersistence.pessimisticUpdate(DiagnosisActions.Add.type, {
    run: (action: any, state) => this.apiService.add(action.payload)
                                      .pipe(map((response: any) => DiagnosisActions.Added({ payload: response }))),
    onError: (action: any, error) => DiagnosisActions.ActionError(action + error)
  }));

  updateEntity$ = createEffect(() => this.dataPersistence.pessimisticUpdate(DiagnosisActions.Update.type, {
    run: (action: any, state) => this.apiService.update(action.payload)
                                      .pipe(map((response: any) => DiagnosisActions.Updated({ payload: response }))),
    onError: (action: any, error) => DiagnosisActions.ActionError(action + error)
  }));

  deleteEntity$ = createEffect(() => this.dataPersistence.pessimisticUpdate(DiagnosisActions.Delete.type, {
    run: (action: any, state) => this.apiService.delete(action.payload)
                                      .pipe(map(response => DiagnosisActions.Deleted({ payload: response }))),
    onError: (action: any, error) => DiagnosisActions.ActionError(action + error)
  }));

  constructor(
    private dataPersistence: DataPersistence<DiagnosisPartialState>,
    private apiService: DiagnosisService,
  ) {}
}
// console.log(`%cDiagnosisEffects::ngOnInit`, 'background:yellow');
